import styled from '@emotion/styled'
import { HoverableInfoIcon } from 'components/patterns'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const StyledHoverableInfoIcon = styled(HoverableInfoIcon)`
  margin-left: 5px;
  display: inline-flex;
`
